import { Skeleton } from '@progress/kendo-react-indicators';

const COLUMN_WIDTHS = ['24px', '130px', '1fr', '1fr', '90px', '1fr', '110px', '160px'];
const ROW_COUNT = 5;

const rowStyle: React.CSSProperties = {
  display: 'grid',
  gridTemplateColumns: COLUMN_WIDTHS.join(' '),
  gap: '16px',
  alignItems: 'center',
  padding: '10px 12px',
  borderBottom: '1px solid #dee2e6',
};

/** Placeholder shaped like DistributionGrid while audits load (including API retries). */
const DistributionGridSkeleton = () => (
  <div aria-busy="true" aria-label="Loading SBCs">
    <div style={{ border: '1px solid #dee2e6' }}>
      <div style={{ ...rowStyle, backgroundColor: '#f8f9fa' }}>
        {COLUMN_WIDTHS.map((_, i) => (
          <Skeleton key={i} shape="text" style={{ height: '14px' }} />
        ))}
      </div>
      {Array.from({ length: ROW_COUNT }, (_, row) => (
        <div key={row} style={rowStyle}>
          {COLUMN_WIDTHS.map((_, i) => (
            <Skeleton key={i} shape="text" style={{ height: '16px' }} />
          ))}
        </div>
      ))}
      <div style={{ display: 'flex', gap: '8px', padding: '10px 12px' }}>
        <Skeleton shape="rectangle" style={{ width: '180px', height: '28px' }} />
        <Skeleton
          shape="rectangle"
          style={{ width: '120px', height: '28px', marginLeft: 'auto' }}
        />
      </div>
    </div>
    <div className="action-buttons" style={{ marginTop: '20px' }}>
      <Skeleton shape="rectangle" style={{ width: '190px', height: '36px' }} />
      <Skeleton
        shape="rectangle"
        style={{ width: '200px', height: '36px', marginLeft: 'auto' }}
      />
    </div>
  </div>
);

export default DistributionGridSkeleton;
